<template>
  <CommonCard>
    <div style="padding: 2%">
      <v-container>
        <v-row v-if="rol == 'VALIDADORCC' || rol == 'MANAGERCC'">
          <v-col cols="9"></v-col>
          <v-col cols="3">
            <v-select
              outlined
              v-model="opcionValidador"
              :items="opcionesValidador"
              item-text="label"
              item-value="id"
              label="Selecciona tipo de llamada validador"
              :clearable="false"
              :class="[
                'v-input--is-focused',
                'v-input--is-dirty',
                opcionValidador == 2
                  ? 'select-focus-fijo-green'
                  : 'select-focus-fijo-blue',
              ]"
            />
          </v-col>
        </v-row>
        <v-row v-if="showAvailabilitySelect">
          <v-col cols="9"></v-col>
          <v-col cols="3">
            <v-select
              outlined
              readonly
              :value="availabilityStatus"
              :items="availabilityOptions"
              item-text="label"
              item-value="id"
              label="Estatus de disponibilidad"
              :clearable="false"
              :class="[
                'v-input--is-focused',
                'v-input--is-dirty',
                availabilitySelectClass,
              ]"
            />
          </v-col>
        </v-row>
        <v-row class="mb-10" dense>
          <v-col cols="9">
            <span class="text-title-tables">Leads</span>
          </v-col>
          <v-col cols="2" style="align-items: end">
            <div class="d-flex align-items-center justify-space-between">
              <span class="text-elements-table">Elementos por página</span>
              <select name="choice" class="number" v-model="size">
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="40">40</option>
                <option value="50">50</option>
              </select>
            </div>
          </v-col>
          <v-col cols="1" style="text-align: end">
            <span
              class="text-elements-table"
              @click="$router.push('/leads/buscar')"
              style="cursor: pointer"
            >
              Filtrar
              <v-icon class="mr-1">mdi-filter-variant</v-icon>
            </span>
          </v-col>

          <v-spacer />
        </v-row>
        <v-row dense align="center">
          <v-col cols="10">
            <v-text-field
              class="share-bar-clase"
              label="Buscar"
              outlined
              dense
              prepend-inner-icon="mdi-magnify"
              :light="true"
              v-model="filter"
              hint="Puedes buscar por: Nombre(s), Apellido(s), Correo y Campaña"
            >
            </v-text-field>
          </v-col>
          <v-col cols="2" style="text-align: end; margin-bottom: 25px">
            <span class="button-span-style" @click="$router.push('/crear-lead')"
              >Crear nuevo lead
              <v-icon color="#039ECC" class="mr-1"
                >mdi-plus-circle-outline</v-icon
              ></span
            >
          </v-col>
        </v-row>
      </v-container>
      <v-container class="pt-5">
        <v-row>
          <!-- <v-col
            cols="12"
            md="6"
            v-if="rol != 'AGENTCC' && rol != 'AGENTCCSPONSORS'"
          >
            <LeadsMarcacion :bus="bus" />
          </v-col> -->
          <v-col cols="12" md="12">
            <LeadsAgenda :size="size" :filter="filter" />
          </v-col>
        </v-row>
      </v-container>
      <!-- <CommonActionModal
        v-if="showCreacion"
        :dialog="showCreacion"
        @closeModal="showCreacion = false"
        @userChoice="userChoice"
        title="Crear nuevo lead"
        subtitle="¿Ya tiene una póliza emitida desde el portal de la aseguradora?"
        bottonText="Si"
        bottonTextCancel="No"
      /> -->
      <!-- <CrearLead
        v-if="showCreacion"
        :show="showCreacion"
        @close="showCreacion = false"
        @leadCreado="leadCreado"
      /> -->
    </div>
    <validador
      v-if="
        (rol == 'VALIDADORCC' || rol == 'MANAGERCC') && opcionValidador == 1
      "
    />
  </CommonCard>
</template>

<script>
import logoSegurify from "@/assets/logo_segurify.png";
import LeadsAgenda from "@/components/leads/LeadsAgenda";
import { loadScript } from "vue-plugin-load-script";
import LogoSegurify from "@/assets/logo_segurify.png";
import LogoBradescard from "@/assets/logo-inter-horizontal.png";
import Vue from "vue";
import CommonCard from "../../../components/commonComponents/CommonCard.vue";
import { mainAxios } from "@/mainAxios.js";
import {
  getValidadoresLista,
  getLlamadaMasiva,
  updateValidadorEstatus,
  updateLead,
} from "@/services/leads/leads.service.js";
import { getDisposicionesByOrigenID } from "@/services/campaings/campaing.service";
import validador from "@/components/validador/validador.vue";
import { updateValidador } from "@/services/validador/validador.service.js";
import {
  createAvailability,
  getAvailabilities,
  setAgentNotReady as setAgentNotReadyService,
} from "@/services/disponibilidad/disponibilidad.service";
import { getCurrentCallCenter } from "@/services/callcenter/callcenter.service";
import { getAgenteByUuid } from "@/services/user/user.service";

export default {
  components: {
    LeadsAgenda,
    CommonCard,
    validador,
  },

  data() {
    return {
      logoSegurify,
      rol: JSON.parse(localStorage.getItem("roles"))[0].rol,
      showCreacion: false,
      bus: new Vue(),
      intervaloActivo: false,
      pollingTimeoutId: null,
      data: [],
      body: {
        pathname: window.location.pathname,
      },
      isChecking: false,
      logo_1: LogoSegurify,
      width_log1: 80,
      height_log1: 80,
      logo_2: LogoBradescard,
      width_log2: 80,
      height_log2: 250,
      itemsForPage: 10,
      filter: "",
      size: 10,
      opcionValidador: 1,
      opcionesValidador: [
        {
          id: 1,
          label: "Disponible para transferencia",
        },
        {
          id: 2,
          label: "Marcación automática",
        },
      ],
      availabilityStatus: null,
      availabilityOptions: [
        { id: "ready", label: "Disponible" },
        { id: "busy", label: "En llamada" },
        { id: "aftercall", label: "After call" },
        { id: "not_ready", label: "No disponible" },
        { id: "offline", label: "Desconectado" },
      ],
    };
  },
  created() {
    getCurrentCallCenter().catch((e) => {
      console.error(e);
    });
  },
  mounted() {
    const storageAvailability = JSON.parse(
      sessionStorage.getItem("availability"),
    );
    this.availabilityStatus = storageAvailability?.status ?? null;
    loadScript(
      "https://aligev55.zw-callitonce.alestra.net.mx/agentdesktop/libs/servicepattern-sdk-v1.js",
    )
      .then(() => {
        window.bpspat.api.init("https://aligev55.zw-callitonce.alestra.net.mx");
      })
      .catch(() => {
        console.error(
          "Fallo al carga el sdk, Refresque la pagina para realizar la llamada",
        );
        location.reload();
      });

    setTimeout(() => {
      this.intervaloActivo = true;
      this.pollLoop();
    }, 12000);
    window.addEventListener(
      "beforeunload",
      this.updateDisponibilidadValidadorOnTabClose,
    );
    if (this.rol === "AGENTCC") {
      this.heartbeatInterval = setInterval(() => this.sendHeartbeat(), 15000);
    }
  },
  beforeDestroy() {
    clearInterval(this.heartbeatInterval);
    this.intervaloActivo = false;
    clearTimeout(this.pollingTimeoutId);
    window.removeEventListener("beforeunload", this.updateDisponibilidadValidadorOnTabClose);
  },

  computed: {
    widthLogoSeg() {
      if (this.$vuetify.breakpoint.smAndDown) return "50";
      if (this.$vuetify.breakpoint.mdAndDown) return "50";
      return "80";
    },

    puedeCrear() {
      const rolesValidos = [
        "ADMIN",
        "ADMINCC",
        "MANAGERCC",
        "MANAGER",
        "ADMINAGENT",
        "DIRECTO",
        "OPERACIONES",
        "OPERADOR",
        "AGENTCC",
      ];
      return !!rolesValidos.find((e) => e == this.rol);
    },
    showAvailabilitySelect() {
      return this.rol == "AGENTCC" || this.rol == "VALIDADORCC";
    },
    availabilitySelectClass() {
      switch (this.availabilityStatus) {
        case "ready":
          return "select-focus-fijo-green";
        case "busy":
          return "select-focus-fijo-blue";
        case "aftercall":
          return "select-focus-fijo-orange";
        case "not_ready":
        case "offline":
          return "select-focus-fijo-gray";
        default:
          return "select-focus-fijo-blue";
      }
    },
  },
  watch: {
    opcionValidador(val) {
      if (val == 2) this.updateValidadorStatus(0);
    },
  },
  methods: {
    async pollLoop() {
      if (!this.intervaloActivo) return;
      let callCenter = null;
      try {
        callCenter = JSON.parse(localStorage.getItem("callCenter"));
      } catch (e) {
        console.error("Error leyendo callCenter desde localStorage", e);
      }
      if (callCenter?.asignacion) {
        await this.checkStatus();
      }
      if (this.intervaloActivo) {
        this.pollingTimeoutId = setTimeout(() => this.pollLoop(), 12000);
      }
  },
    getStateAsync() {
      return new Promise((resolve, reject) => {
        try {
          window.bpspat.api.getState(resolve);
        } catch (e) {
          reject(e);
        }
      });
    },

    async checkStatus() {
      try {
        await getCurrentCallCenter();
      } catch (e) {
        console.warn(
          "No se pudo refrescar callCenter, se usará el valor en caché",
          e,
        );
      }
      if (
        (this.rol == "AGENTCC" || this.rol == "VALIDADORCC") &&
        !this.isChecking
      ) {
        this.isChecking = true;
        try {
          const state = await this.getStateAsync();
          await this.statusChecked(state);
        } catch (e) {
          console.error("Error en checkStatus/getState:", e);
        } finally {
          this.isChecking = false;
        }

      }
    },
    async getLlamadaMasiva(body) {
      let callCenter = null;
      try {
        callCenter = JSON.parse(localStorage.getItem("callCenter"));
      } catch (e) {
        console.error("Error leyendo callCenter desde localStorage", e);
      }

      if (this.rol == "AGENTCC" && callCenter?.asignacion === 0) {
        console.log("Assignation === ", 0, " Avoid call");
        return;
      }

      this.data = [];
      try {
        this.data = await getLlamadaMasiva(body);
        if (
          this.data.success === true &&
          (await this.validacionCampanias(this.data.lead))
        ) {
          this.intervaloActivo = false;
          if (this.rol == "AGENTCC") {
            if (callCenter?.marcacion === 0) {
              await this.autoTipificar(this.data.lead);
            }

            this.changeRoute(this.data.lead);
          } else if (this.rol == "VALIDADORCC" || this.rol == "MANAGERCC") {
            this.validadorRuta(this.data.lead);
          }
        } else {
          await updateLead(this.data.lead.uuid);
          console.error("Asigno un lead incorrecto ");
        }
      } catch (error) {
        console.error("Error: ", error);
        console.error("Ha ocurrido un error al traer los leads");
      }
    },
    async autoTipificar(lead) {
      try {
        const disposiciones = await getDisposicionesByOrigenID(lead.id);
        const disposicion = disposiciones.find(
          (d) => d.disposicion === "Atendido Gabbsa",
        );

        if (!disposicion) {
          console.warn(
            "autoTipificar: no se encontró la disposición 'Atendido Gabbsa' para la campaña del lead",
          );
          return;
        }

        const config = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              "agenteAccessToken",
            )}`,
          },
        };
        const request = {
          leadUuid: lead.uuid_lead_segurify,
          origen_uuid: lead.uuid,
          disposicion: disposicion.disposicion,
          codigo_disposicion: String(disposicion.id),
          fecha_agenda: null,
          tipo_llamada: "Outbound",
          globalInteractionId: null,
          isPrimeraLlamada: false,
          callback: 0,
          marcacion_automatica: false,
          agendaValidador: false,
        };
        await mainAxios.post("/v1/accion/lead-segurify/crear", request, config);
      } catch (error) {
        console.error("Error al tipificar automáticamente el lead:", error);
      }
    },
    async statusChecked(state) {
      let callCenter = null;
      try {
        callCenter = JSON.parse(localStorage.getItem("callCenter"));
      } catch (e) {
        console.error("Error leyendo callCenter desde localStorage", e);
      }
      if (callCenter?.asignacion === 0) {
        if (this.availabilityStatus === 'ready') {
          this.setAgentNotReady();
          this.availabilityStatus = 'not_ready';
        }
        return;
      }
      let status = state.data.status;
      await this.createAvailability(state.data);
      let interactions = state?.data?.interactions ?? [];
      switch (status) {
        case "ready":
          if (this.rol == "AGENTCC") await this.getLlamadaMasiva(this.body);
          else if (this.opcionValidador == 2) await this.getValidadoresLista();
          break;
        case "busy": {
          let messages = interactions.filter((e) => e.media_type != "CHAT");
          if (messages.length == 0 && this.rol == "AGENTCC")
            await this.getLlamadaMasiva(this.body);
          break;
        }
      }
    },
    async createAvailability(data) {
      if (data.status === "busy") {
        data = { ...data, status: "ready" };
      }
      const prevAvailability = JSON.parse(
        sessionStorage.getItem("availability"),
      );
      const localAgent = localStorage.getItem("id");
      if (
        !prevAvailability ||
        prevAvailability.status !== data.status ||
        prevAvailability.agent_id !== localAgent
      ) {
        const agentId = localAgent;
        const availabilities = await getAvailabilities();
        const find = availabilities.find((x) => x.agenteId === agentId);
        const payload = {
          agenteId: agentId,
          lastStatusChange: find ? find.status : "created",
        };
        payload.status = data.status;
        if (find) {
          payload.id = find.id;
        }
        const res = await createAvailability(payload);
        if (res.status === 200) {
          const storageAvailability = {
            agent_id: payload.agenteId,
            status: payload.status,
            id: res?.data?.id ?? payload.id ?? find?.id ?? null,
          };
          this.availabilityStatus = payload.status;
          sessionStorage.setItem(
            "availability",
            JSON.stringify(storageAvailability),
          );
        }
      }
    },
    changeRoute(item) {
      let makeCall = true;
      try {
        const callCenter = JSON.parse(localStorage.getItem("callCenter"));
        if (
          callCenter?.marcacion !== undefined &&
          callCenter?.marcacion !== null
        ) {
          makeCall = callCenter.marcacion == 1;
        }
      } catch (e) {
        console.error(e);
      }
      this.$router.push({
        path: "/segurify/leads-segurify/lead/" + item.uuid_lead_segurify,
        query: {
          llamadaMasiva: makeCall,
          origenLeadUuid: item.uuid,
        },
      });
    },
    async updateValidadorEstatus(item) {
      return await updateValidadorEstatus(
        item.uuid,
        localStorage.getItem("id"),
      );
    },
    async getValidadoresLista() {
      this.data = await getValidadoresLista();
      this.completarllamadaAuto();
    },
    validadorRuta(item) {
      this.$router.push({
        path: "/segurify/leads-segurify/lead/" + item.uuid_lead_segurify,
        query: {
          llamadaValidador: true,
          origenLeadUuid: item.uuid,
          llamadaMasivaValidador: true,
        },
      });
    },
    async updateValidadorStatus(isDisponible) {
      try {
        await updateValidador(isDisponible);
      } catch {
        console.error("Error a actualizar validador.");
      }
    },
    updateDisponibilidadValidadorOnTabClose() {
      // Método utilizado para los casos en que el usuario (validador) cierra la pestaña y se asegura de que el status de disponible se quede en 0
      const url = `${process.env.VUE_APP_API_URL}/v1/update/validador/disponible?isDisponible=0`;
      if (this.rol === "VALIDADORCC" || this.rol == "MANAGERCC") {
        fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem(
              "agenteAccessToken",
            )}`,
          },
          keepalive: true,
        });
      }
      if (this.rol === "AGENTCC") {
        this.setAgentNotReady();
      }
    },
    setAgentNotReady() {
      const prevAvailability = JSON.parse(
        sessionStorage.getItem("availability"),
      );
      const agentId = localStorage.getItem("id");
      if (!agentId) return;
      setAgentNotReadyService(agentId, prevAvailability);
      sessionStorage.removeItem("availability");
    },
    sendHeartbeat() {
      const agentId = localStorage.getItem("id");
      const prevAvailability = JSON.parse(
        sessionStorage.getItem("availability") || "null",
      );
      if (!agentId || !prevAvailability || prevAvailability.status !== "ready")
        return;
      createAvailability({
        agenteId: agentId,
        status: "ready",
        lastStatusChange: prevAvailability.status ?? "ready",
        id: prevAvailability.id ?? null,
      }).catch(() => {});
    },
    async validacionCampanias(lead) {
      let landings = await this.getCampaniasAgent();
      return landings.includes(lead.campania_id ?? false);
    },
    async getCampaniasAgent() {
      let agente = await getAgenteByUuid(localStorage.agenteUuid ?? null);
      return agente.landings ?? [];
    },
  },
  beforeRouteLeave(to, from, next) {
    this.intervaloActivo = false;
    clearTimeout(this.pollingTimeoutId);
    if (this.rol === "VALIDADORCC" || this.rol == "MANAGERCC") {
      this.updateValidadorStatus(0)
        .then(() => next())
        .catch((e) => {
          console.error("Error al cambiar el status del validador:", e);
          next();
        });
    } else if (this.rol === "AGENTCC") {
      if (to.query.llamadaMasiva !== "true") {
        this.setAgentNotReady();
      }
      next();
    } else {
      next();
    }
  },
};
</script>

<style>
.select-focus-fijo-green .v-input__slot {
  border-width: 2px;
  border-color: #35a40f !important; /* tu color de foco */
  color: #35a40f !important;
}
.select-focus-fijo-green .v-label {
  color: #093e4c !important;
}

.select-focus-fijo-blue .v-input__slot {
  border-width: 2px;
  border-color: #039ecc !important; /* tu color de foco */
  color: #039ecc !important;
}
.select-focus-fijo-blue .v-label {
  color: #093e4c !important;
}

.select-focus-fijo-orange .v-input__slot {
  border-width: 2px;
  border-color: #f39c12 !important;
  color: #f39c12 !important;
}
.select-focus-fijo-orange .v-label {
  color: #093e4c !important;
}

.select-focus-fijo-gray .v-input__slot {
  border-width: 2px;
  border-color: #7f8c8d !important;
  color: #7f8c8d !important;
}
.select-focus-fijo-gray .v-label {
  color: #093e4c !important;
}
</style>
